module.exports = __webpack_public_path__ + "img/pr-16.f044fc0b.png";